
<div class="admin">
	<header>
		<div class="logo"></div>
	</header>
	<router-outlet></router-outlet>
</div>

<p-confirmDialog />